export const getTenantIdFromStorage = () => {
  try {
    const info = JSON.parse(localStorage.getItem('organizationInfo'))
    return info?.id || 'default'
  } catch (err) {
    return 'default'
  }
}

export const withTenantKey = baseKey => `${baseKey}_${getTenantIdFromStorage()}`
